import React from 'react'
import {Link} from 'react-router-dom';
const Navbar = () => {

    return (
      <nav class="navbar navbar-expand-lg navbar-dark p-3">
      <Link class="navbar-brand" to='/'>Lynx</Link>
      <button class="navbar-toggler" style={{border:'none'}} type="button" data-toggle="collapse" data-target="#navbarColor01" aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    
      <div class="collapse navbar-collapse" id="navbarColor01">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <Link class="nav-link" to='/'>Home</Link>
          </li>
          <li class="nav-item">
            <Link class="nav-link" to='/about'>About</Link>
          </li>
        </ul>
      
      </div>
    </nav>
    )
}

export default Navbar
